var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simulation-preview"},[(_vm.showed)?_c('FakeSimulation',{attrs:{"custom-logo-url":_vm.schema.systemSlideLogoUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }